export default __webpack_public_path__ + "static/media/twickCollage2.381a0ec1.jpg";